import Meta from 'vue-meta'
import Router from 'vue-router'
import Vue from 'vue'

import beforeEach from './beforeEach'
import routes from './routes'
import scrollBehavior from './scrollBehavior'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'is-active-route',
  linkExactActiveClass: 'is-exact-active-route',
  routes,
  scrollBehavior
})

router.beforeEach(beforeEach)

export default router
